import { Label } from "evergreen-ui";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 1rem 0px;
  overflow: hidden;
  @media (max-width: ${(props) => props.theme.maxWidth}) {
    flex-direction: column;
    padding: 1rem;
  }
`;

const Title = styled.h1`
  ${(props) => props.theme.title};
  margin-bottom: 1rem;
`;
const TitleBox = styled.div`
  padding: 1rem;
  width: 40vw;
  @media (max-width: ${(props) => props.theme.maxWidth}) {
    width: 100%;
  }
`;

const WhiteBox = styled.form`
  ${(props) => props.theme.whiteBox};
  width: 100%;
`;

const Footer = styled.div`
  background-color: ${(props) => props.theme.extraLightGreyColor};
  width: 100%;
  padding: 1rem;
`;
interface IProps {
  content?: any;
  footer?: any;
  title: string;
  onSubmit?: any;
  description?: any;
}
const InfoBox: React.SFC<IProps> = ({
  onSubmit,
  title,
  content,
  footer,
  description,
}) => {
  return (
    <Container>
      <TitleBox>
        <Title>{title}</Title>
        <Label>{description}</Label>
      </TitleBox>
      <WhiteBox onSubmit={onSubmit}>
        {content}
        {footer && <Footer>{footer}</Footer>}
      </WhiteBox>
    </Container>
  );
};

export default InfoBox;
